import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { RegistrationResponse } from "../registration.model";

import { REGISTRATION_WITH_PERSONAL_NUMBER_ACTION_TYPE } from "./registration-with-personal-number.action";
import {
	RegistrationWithPersonalNumberCompletePayload,
	RegistrationWithPersonalNumberState,
} from "./registration-with-personal-number.model";

const INITIAL_STATE: RegistrationWithPersonalNumberState = {
	personalNumber: undefined,
	personalNumberInformationLevel: undefined,
	submittedPersonalNumber: undefined,
	submittedPersonalNumberInformationLevel: undefined,
	registrationDetails: undefined,
	token: undefined,
};

export function registrationWithPersonalNumberReducer(
	state = INITIAL_STATE,
	action: ActionWithPayload
): RegistrationWithPersonalNumberState {
	switch (action.type) {
		case REGISTRATION_WITH_PERSONAL_NUMBER_ACTION_TYPE.verifyPersonalNumber: {
			return updateState(state, {
				personalNumber: action.payload,
				personalNumberInformationLevel: undefined,
				submittedPersonalNumber: state.personalNumber,
				submittedPersonalNumberInformationLevel: state.personalNumberInformationLevel,
			});
		}
		case REGISTRATION_WITH_PERSONAL_NUMBER_ACTION_TYPE.resetRegistrationDetails: {
			return updateState(state, {
				registrationDetails: undefined,
			});
		}
		case REGISTRATION_WITH_PERSONAL_NUMBER_ACTION_TYPE.resetPersonalNumber: {
			return updateState(state, {
				personalNumber: undefined,
			});
		}
		case REGISTRATION_WITH_PERSONAL_NUMBER_ACTION_TYPE.resetInformationLevel: {
			return updateState(state, {
				personalNumberInformationLevel: undefined,
			});
		}
		case REGISTRATION_WITH_PERSONAL_NUMBER_ACTION_TYPE.resetState: {
			return INITIAL_STATE;
		}
		case REGISTRATION_WITH_PERSONAL_NUMBER_ACTION_TYPE.verifyPersonalNumberSuccess: {
			return updateState(state, {
				personalNumber: action.payload.personalNumber,
				personalNumberInformationLevel: action.payload.informationLevel,
			});
		}
		case REGISTRATION_WITH_PERSONAL_NUMBER_ACTION_TYPE.getRegistrationTokenCompleteFlow: {
			return updateState(state, {
				token: undefined,
				hashedEmail: undefined,
				registrationDetails: formatRegistrationRequest(action.payload),
			});
		}
		case REGISTRATION_WITH_PERSONAL_NUMBER_ACTION_TYPE.getRegistrationTokenSimpleFlow: {
			return updateState(state, {
				token: undefined,
				hashedEmail: undefined,
				registrationDetails: action.payload,
			});
		}
		case REGISTRATION_WITH_PERSONAL_NUMBER_ACTION_TYPE.getRegistrationTokenCompleteFlowSuccess:
		case REGISTRATION_WITH_PERSONAL_NUMBER_ACTION_TYPE.getRegistrationTokenSimpleFlowSuccess: {
			const response = action.payload as RegistrationResponse;
			return updateState(state, {
				token: response.token,
				hashedEmail: response.hashedEmail,
			});
		}
		default:
			return state;
	}
}

function formatRegistrationRequest(
	payload: RegistrationWithPersonalNumberCompletePayload
): RegistrationWithPersonalNumberCompletePayload {
	if (payload.person && payload.person.dateOfBirth) {
		payload.person.dateOfBirth = new Date(payload.person.dateOfBirth).toISOString();
	}
	return payload;
}
